module.exports = __webpack_public_path__ + "static/media/gloce-icon.44023725.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gloce-icon.svg
// module id = 1070
// module chunks = 0